function NewInDepthSet(defaultFolderId) {
    return {
        id: null,       
        name: "New Question Set",
		startDate: null,
		endDate: null,
		folderId: defaultFolderId,
		enabled: 0,
		isNetquest: false,
		uploadedSchemaFileName: null,
		forceSchemaQuestionUpdate: false,
		filterSets: [
			NewFilterSet()
		]
      }
}

export function NewFilterSet() {
	return {
		id: null,
		name: "New Filter Set",
		inArchive: 0,
		questions: [],
		programSelection: {
			isForNonMatchedPrograms: 0,
			titles: [],
			genres: [],
			channels: [],
			broadcasters: []
		}
	}
}

export default NewInDepthSet;